export default __webpack_public_path__ + "static/media/img_avatar1.8e7c951b.svg";